import { Component, ContentChildren, Input, OnInit, QueryList } from '@angular/core';
import { LocaleRouterService } from '@shared/services/locale-router.service';

@Component({
    selector: 'inka-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {
  @Input() backButtonLightColor = false;

  @Input() hideTimer: boolean = false;
  @Input() header?: string;

  @ContentChildren('*') allContentEls!: QueryList<Component>;

  constructor(private router: LocaleRouterService) {
  }

  ngOnInit(): void {
  }

  back() {
    this.router.games();
  }
}
